import {inject, singleton} from "tsyringe";
import {CommandHandler} from "../../decorators/command-handler.decorator";
import {appState} from "../../app.state";
import {TimelineToggleWeeklyViewCommand} from "../timeline-toggle-weekly-view.command";
import {ICommand} from "../i-command.interface";
import {ICommandHandler} from "./i-command.handler";

@CommandHandler(TimelineToggleWeeklyViewCommand)
@singleton()
export class TimelineToggleWeeklyViewCommandHandler implements ICommandHandler<void> {
    
    public async handle(command: ICommand<void>): Promise<void> {
        // Nur den State togglen - View-Updates passieren über Subscription
        appState.setCellWidthView(appState.isWeekView() ? 'standard' : 'detail');
    }
}